<template>
  <div>
    <span
      class="mx-1"
      color="primary"
      depressed
      rounded
      small
      v-if="params && params.data && params.data.storage_type"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            small
            :style="{ color: params.data.storage_type_color }"
          >
            mdi-checkbox-blank
          </v-icon>
        </template>
        <span class="text-capitalize">{{ params.data.storage_type }}</span>
      </v-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
